import React from 'react';
import { WorkspaceContainer }  from '../../containers';

const WorkspacePage: React.FC<{}> = () => (
  <>
    <WorkspaceContainer />
  </>
)

export default WorkspacePage;